module.exports = __webpack_public_path__ + "static/media/BLZD-BNB.fb35e681.png";